import {types} from '../../types';

const setGetGroupsAction = (payload) => {
    return {
      type: types.cashier.SET_GROUPS,
      payload,
    }
}

const setGetDailyListAction = (payload) => {
  return {
      type: types.cashier.SET_DAYLI,
      payload,
    }
}

const setGetShiftAction = (payload) => {
  return {
      type: types.cashier.SET_SHIFT,
      payload,
    }
}

const setGroupsViewAction = (payload) => {
  return {
      type: types.cashier.SET_GROUPS_VIEW,
      payload,
    }
}

const setGetGamerInformationAction = (payload) => {
  return {
    type: types.cashier.SET_COUNT_GAMER,
    payload
  }
}

const setGetOperatorDetalizationAction = (payload) => {
  return {
    type: types.cashier.SET_OPERATOR_DETALIZATION,
    payload
  }
}

const setGetBetAction = (payload) => {
  return {
    type: types.cashier.SET_BET,
    payload
  }
}

export {
  setGetGroupsAction as SetGetGroupsAction,
  setGetDailyListAction as SetGetDailyListAction,
  setGetShiftAction as SetGetShiftAction,
  setGroupsViewAction as SetGroupsViewAction,
  setGetGamerInformationAction as SetGetGamerInformationAction,
  setGetOperatorDetalizationAction as SetGetOperatorDetalizationAction,
  setGetBetAction as SetGetBetAction
}